import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../../store';
import * as AppealListStore from '../../store/AppealListStore';
import * as AccountStore from '../../store/AccountStore'
import * as GuideStore from '../../store/GuideStore';
import { Loader, Spinner } from '../components/Loader';
import AccountSelector from '../components/AccountSelector';
import Switcher from '../components/Switcher';
import Navigation from '../../constants/enums/NavigationEnum';
import DataString from '../components/DataString';
import listArrowIcon from '../../images/listArrowIcon.svg'
import ScoreSelector from '../components/ScoreSelector';
import detailsIcon from '../../images/detailsIcon.svg'
import { SetHtmlOverflow, Modal, Popup } from '../components/Modals';
import InfoPanel from '../components/InfoPanel';
import ParamSelector from '../components/ParamSelector';
import Input, { AddressInput, Checkbox, DateInput, FileInput } from '../components/Input';
import clipIcon from '../../images/clipIcon.svg'
import { FileViewer } from '../components/FilePanels';
import NumberSelector from '../components/NumberSelector';
import CloseIcon from '../../images/dynamicIcons/closeIcon';
import BackIcon from '../../images/dynamicIcons/backIcon';
import { groupBy, isArray, map, orderBy, update } from 'lodash';
import moment from 'moment';
import { AppealAdditionalTag, AppealData, AppealTag, AppealTagParameter, AppealTopic, Dictionary, Parameter, ParameterTagTypeEnum, ShortAppealData, TaskTagParameter } from '../../models/AppealReferanceModels';
import { AppealRequests } from '../../apiRequests/AppealRequests';
import { ToastNotificationManager } from '../../infrastructure/ToastNotificationManager';
import { NotificationTypeEnum } from '../../models/NotificationModels';
import { title } from 'process';
import ServiceObjectSearch from '../generic/component/ServiceObjectSearch';
import { ServiceObjectTypeNumber } from '../../models/SettingModels';


const dispatchAction = {
    ...AccountStore.actionCreators,

}

type AppealListProps =
    AppealListStore.AppealListState &
    AccountStore.AccountStateState &
    GuideStore.GuideState &
    typeof dispatchAction &
    RouteComponentProps<{ Create: string | undefined }>;

interface AppealListState {
    selectedOption: number,
    openAppealKey: string,
    appealCreateIsOpen: boolean,
    appealNamelessCreateIsOpen: boolean,
    appealViewIsOpen: boolean,
    selectedScore: number,
    scoredTaskTagId: string,
    scoreComment: string,
    appealSuccessIsOpen: boolean,
    appealKeySuccessIsOpen: boolean,
    ratingHighIsOpen: boolean,
    ratingIsOpen: boolean,
    addPaIsOpen: boolean,
    uploadedTaskTag: AppealData | null,
    viewInProgress: boolean,
    selectedTopicId: string
    selectedTagsInfo: { id: string, isLoading: boolean, params: AppealTagParameter[], appealName: string, appealAdditionalTagIds: string[], parameters: Dictionary<any> }[],
    appealInProgress: boolean,
    scoreInProgress: boolean,
    fileLoading: boolean,
    serviceObjectId: number | null;

}

class AppealListPage extends React.PureComponent<AppealListProps, AppealListState> {

    private apiAppealRequest = new AppealRequests();

    constructor(props: AppealListProps) {
        super(props);
        this.state = {
            selectedOption: 0, openAppealKey: "",
            appealCreateIsOpen: this.props.match.params.Create !== undefined,
            appealNamelessCreateIsOpen: false,
            appealViewIsOpen: false,
            selectedScore: -1,
            scoredTaskTagId: "",
            scoreComment: "",
            appealSuccessIsOpen: false,
            appealKeySuccessIsOpen: false,
            ratingHighIsOpen: false,
            ratingIsOpen: false,
            addPaIsOpen: false,
            uploadedTaskTag: null,
            viewInProgress: false,
            selectedTopicId: "",
            selectedTagsInfo: [],
            appealInProgress: false,
            scoreInProgress: false,
            fileLoading: false,
            serviceObjectId: null,
        }
    }

    async componentDidMount() {
        if (this.props.tubeTaskTagTemplete !== null && this.props.match.params.Create === ":tubeTaskTag") {

            let newSelectedTagsInfo: {
                id: string,
                isLoading: boolean,
                params: AppealTagParameter[],
                appealName: string,
                appealAdditionalTagIds: string[],
                parameters: Dictionary<any>,
            }[] = []

            newSelectedTagsInfo.push({ id: this.props.tubeTaskTagTemplete.appealTagId, isLoading: false, params: [], appealName: "Трубка", appealAdditionalTagIds: [], parameters: {} });
            let params = await this.apiAppealRequest.GetAppealTagParameterInformation(this.props.tubeTaskTagTemplete.appealTagId);

            if (!params.result) {
                ToastNotificationManager.SendToast({
                    type: NotificationTypeEnum.danger,
                    message: `Ошибка загрузки параметров раздела.`,
                });
            }
            else {

                newSelectedTagsInfo[newSelectedTagsInfo.length - 1].isLoading = true;
                newSelectedTagsInfo[newSelectedTagsInfo.length - 1].params = params?.data || [];

                await this.setState({ selectedTagsInfo: newSelectedTagsInfo, selectedTopicId: this.props.tubeTaskTagTemplete?.appealTopicId || "" })
            }


        }
    }



    private Appeals_Render() {

        var account = this.props.accounts[this.props.selectedAccount]
        var activeAppeals: ShortAppealData[] = [];
        var doneAppeals: {
            index: string;
            element: ShortAppealData[];
        }[] = []
        try {
            var activeAppeals = orderBy(account.appeals.filter(e => e.taskTagStatusName === "Активна"), e => e.dateCreate, "desc");
            var doneAppeals = orderBy(map(groupBy(account.appeals.filter(e => e.taskTagStatusName !== "Активна"), e => moment(e.dateCreate).format("YYYY")), (e, key) => { return { index: key, element: e } }), e => e.index, "desc");
        }
        catch { }

        switch (this.state.selectedOption) {
            /*нет лс, нет заявок, есть лс и заявки */
            case 0:
                if (this.props.accounts.length === 0)
                    return <div className='appeal__list_wrapper--no-appeal'>
                        <div className='text-bold'>У вас нет активных заявок. Для просмотра статуса выполнения заявки в личном кабинете, добавьте лицевой счет</div>
                    </div>

                else if (activeAppeals.length === 0)
                    return <div className='appeal__list_wrapper--no-appeal'>
                        <div className='text-bold'>На данном лицевом счете нет активных заявок</div>
                    </div>
                else return <div className='appeal__list_wrapper'>
                    <div className='appeal__list_roller_wrapper'>
                        {activeAppeals.map((element, index) => {
                            return <div className='appeal__list_card' key={index}>
                                <div className='appeal__list_card_status inWork appeal-status-text'>{element.taskTagStatusName}</div>
                                <DataString title='' value={`Заявка № ${element.serialNumber}`} />
                                <DataString title='Дата создания' value={moment(element.dateCreate).format("DD.MM.YYYY")} />
                                <DataString title='Тема' value={element.appealTopicName} />
                                <DataString title='Раздел' value={element.appealTagName} />
                            </div>
                        })}
                    </div>
                </div>
            case 1:
                if (this.props.accounts.length === 0)
                    return <div className='appeal__list_wrapper--no-appeal'>
                        <div className='text-bold'>У вас нет выполненных заявок. Для просмотра статуса выполнения заявки в личном кабинете, добавьте лицевой счет</div>
                    </div>

                else if (doneAppeals.length === 0)
                    return <div className='appeal__list_wrapper--no-appeal'>
                        <div className='text-bold'>На данном лицевом счете нет выполненных заявок</div>
                    </div>
                else return <div className='appeal__list_wrapper'>

                    <div className='appeal__list_without-date '>
                        {orderBy(doneAppeals[0].element, e => e.dateCreate, "desc").map((element, index) => {
                            return <div className='appeal__list_card' key={index}>
                                <div className='appeal__list_card_status completed appeal-status-text'>{element.taskTagStatusName}</div>
                                <DataString title='' value={`Заявка № ${element.serialNumber}`} />
                                <DataString title='Дата создания' value={moment(element.dateCreate).format("DD.MM.YYYY")} />
                                <DataString title='Тема' value={element.appealTopicName} />
                                <DataString title='Раздел' value={element.appealTagName} />


                                {element.quality !== null && element.quality !== 0 ?
                                    <DataString title='Оцените работу по заявке' >
                                        <ScoreSelector selectedScore={element.quality} isView={true} />
                                    </DataString>
                                    :
                                    <DataString title='Ваша оценка' >
                                        <ScoreSelector selectedScore={0}
                                            score_onClick={(score) => this.setState({ selectedScore: score, scoredTaskTagId: element.taskTagId })} />
                                    </DataString>}
                                <div className='appeal__list_card_details' onClick={() => this.setState({ appealViewIsOpen: true })}>
                                    <div className='details-text'
                                        onClick={async () => await this.DoneAppealDetails_onClick(element.taskTagId)}>Подробнее</div>
                                    <img src={detailsIcon} />
                                </div>
                            </div>
                        })}

                    </div>
                    {
                        doneAppeals.slice(1).map((element, index) => {
                            return <div className={`appeal__list_roller ${this.state.openAppealKey === element.index && "isOpen"}`} key={index}>
                                <div className='appeal__list_roller_wrapper'>
                                    <div className='appeal__list_roller_header' onClick={() => this.setState({ openAppealKey: this.state.openAppealKey === element.index ? "" : element.index })}>
                                        <div className='roller_header'>{element.index}</div>
                                        <img src={listArrowIcon}></img>
                                    </div>
                                    {element.element.map((subElement, subIndex) => {
                                        return <div className='appeal__list_card' key={subIndex}>
                                            <div className='appeal__list_card_status completed appeal-status-text'>{subElement.taskTagStatusName}</div>
                                            <DataString title='' value={`Заявка № ${subElement.serialNumber}`} />
                                            <DataString title='Дата создания' value={moment(subElement.dateCreate).format("DD.MM.YYYY")} />
                                            <DataString title='Тема' value={subElement.appealTopicName} />
                                            <DataString title='Раздел' value={subElement.appealTagName} />
                                            {subElement.quality !== null && subElement.quality !== 0 ?
                                                <DataString title='Оцените работу по заявке' >
                                                    <ScoreSelector selectedScore={0} isView={true} />
                                                </DataString>
                                                :
                                                <DataString title='Ваша оценка' >
                                                    <ScoreSelector selectedScore={this.state.selectedScore}
                                                        score_onClick={(score) => this.setState({ selectedScore: score, scoredTaskTagId: subElement.taskTagId })} />
                                                </DataString>}

                                            <div className='appeal__list_card_details' onClick={() => this.setState({ appealViewIsOpen: true })}>
                                                <div className='details-text'
                                                    onClick={async () => await this.DoneAppealDetails_onClick(subElement.taskTagId)}>Подробнее</div>
                                                <img src={detailsIcon} />
                                            </div>
                                        </div>
                                    })}

                                </div>
                            </div>
                        }
                        )
                    }
                </div>
        }

    }

    private async DoneAppealDetails_onClick(taskTagId: string) {

        await this.setState({ viewInProgress: true, appealViewIsOpen: true });
        let response = await this.apiAppealRequest.GetAccountAppealData(taskTagId);
        if (!response.result) {
            ToastNotificationManager.SendToast({
                type: NotificationTypeEnum.danger,
                message: `Не удалось загрузить подробности заявки.`,
            })
            await this.setState({ viewInProgress: false, appealViewIsOpen: false })
        }
        else
            await this.setState({ viewInProgress: false, uploadedTaskTag: response.data })

    }

    private ParametersInput_onChange(index: number, key: string, value: any) {
        let newSelectedTagsInfo = this.state.selectedTagsInfo.slice();
        newSelectedTagsInfo[index].parameters[key] = value;
        this.setState({ selectedTagsInfo: newSelectedTagsInfo, fileLoading: false })
    }

    async GetFile(file: { id: string, name: string }) {

        if (file && file.id) {
            let resultReuest = await this.apiAppealRequest.GetAppealClientFile(file.id);

            if (resultReuest != null) {
                var fileDownload = require('js-file-download');
                fileDownload(resultReuest, file.name || '--');
            }
            else {
                ToastNotificationManager.SendToast({
                    type: NotificationTypeEnum.danger,
                    message: `Ошибка при получние файла. Попробуйте позже`
                });
            }
        }
        else ToastNotificationManager.SendToast({
            type: NotificationTypeEnum.danger,
            message: `Ошибка при получние файла. Попробуйте позже`
        });
    }

    private ParametersInput_Render(index: number) {
        let result: JSX.Element[] = [];

        orderBy(orderBy(this.state.selectedTagsInfo[index].params,
            e => e.parameterTagType === ParameterTagTypeEnum.Date),
            e => e.parameterTagType === ParameterTagTypeEnum.File || e.parameterTagType === ParameterTagTypeEnum.FileCollection).forEach((element, ind) => {
                if (!element.IsIgnoreCreate)
                    switch (element.parameterTagType) {
                        case ParameterTagTypeEnum.Text:
                            result.push(<Input type='string' key={ind} placeholder={element.description} isRequired={element.isRequired}
                                onChange={(value) => { this.ParametersInput_onChange(index, element.parameterName, { ["text"]: value }) }} />); break;
                        case ParameterTagTypeEnum.TextArea:
                            result.push(<Input key={ind} type='text' placeholder={element.description} isRequired={element.isRequired}
                                onChange={(value) => { this.ParametersInput_onChange(index, element.parameterName, { ["text"]: value }) }} />); break;
                        case ParameterTagTypeEnum.Date:
                            result.push(<div key={ind}>
                                <DateInput placeholder={element.description} isRequired={element.isRequired}
                                    onChange={(value) => { this.ParametersInput_onChange(index, element.parameterName, { ["date"]: value }) }} /></div>); break;
                        case ParameterTagTypeEnum.CheckReadObly:
                            result.push(<Checkbox title={element.description} isRequired={element.isRequired}
                                onChange={(value) => { this.ParametersInput_onChange(index, element.parameterName, { ["bool"]: value }) }} />); break;
                        case ParameterTagTypeEnum.File:
                            result.push(<FileInput onStartChange={async () => await this.setState({ fileLoading: true })} key={ind} title={element.description} isRequired={element.isRequired}
                                onChange={(value) => { this.ParametersInput_onChange(index, element.parameterName, { ["file"]: value }) }} />); break;
                        case ParameterTagTypeEnum.FileCollection:
                            result.push(<FileInput onStartChange={async () => await this.setState({ fileLoading: true })} key={ind} title={element.description} multiple={true} isRequired={element.isRequired}
                                onChange={(value) => { this.ParametersInput_onChange(index, element.parameterName, { ["files"]: value }) }} />); break;
                        default: break;
                    }
            })
        return result;
    }

    private ParametersView_Render(parameters: TaskTagParameter[] | undefined) {
        let result: JSX.Element[] = [];
        if (parameters !== undefined && parameters.length !== 0) {
            orderBy(orderBy(parameters,
                e => e.parameterTagType === ParameterTagTypeEnum.Date),
                e => e.parameterTagType === ParameterTagTypeEnum.File || e.parameterTagType === ParameterTagTypeEnum.FileCollection).forEach((element, ind) => {
                    if (element.value !== null)
                        switch (element.parameterTagType) {
                            case ParameterTagTypeEnum.Text:
                            case ParameterTagTypeEnum.TextArea:
                            case ParameterTagTypeEnum.TextWithCode:
                                let val = (element.value as Dictionary<any>)["text"];
                                if (val !== null && val !== "")
                                    result.push(<DataString key={ind} title={element.description}>{(element.value as Dictionary<any>)["text"]}</DataString>); break;
                            case ParameterTagTypeEnum.Date:
                                val = (element.value as Dictionary<any>)["date"];
                                if (val !== null && val !== "")
                                    result.push(<DataString key={ind} title={element.description}>{(element.value as Dictionary<any>)["date"]}</DataString>); break;
                            case ParameterTagTypeEnum.CheckReadObly:
                                result.push(); break;
                            case ParameterTagTypeEnum.File:
                                val = (element.value as Dictionary<any>)["file"];
                                if (val !== null)
                                    result.push(<DataString key={ind} title={element.description}>
                                        <FileViewer onClick={(index: number) => { this.GetFile(val) }} data={[val.name]} />
                                    </DataString>);
                                break;
                            case ParameterTagTypeEnum.FileCollection:
                                val = (element.value as Dictionary<any>)["files"];
                                if (val !== null) {
                                    let ar = val as Array<{ id: string, name: string }>
                                    if (ar.length !== 0)
                                        result.push(<DataString key={ind} title={element.description}>
                                            <FileViewer onClick={async (index: number) => { this.GetFile(ar[index]) }} data={ar.map(e => e.name)} />
                                        </DataString>);
                                }

                                break;
                            default: break;
                        }
                })
            if (result.length !== 0)
                return <div className='appeal__view_data'><div className='devider--horizontal' />{result}</div>;
            else return [];
        }
        else return []
    }

    private async CreateAppeal() {
        if (this.CheckValid()) {
            await this.setState({ appealInProgress: true });
            let tags = this.state.selectedTagsInfo.map(e => { return { appealTagId: e.id, parameters: e.parameters, appealAdditionalTagsId: e.appealAdditionalTagIds } });
            let command = {
                personalAccountId: this.props.accounts.length !== 0 ? this.props.accounts[this.props.selectedAccount].balance.personalAccountId : "",
                serviceObjectId: this.props.accounts.length === 0 ? this.state.serviceObjectId : 0,
                taskAppeals: [
                    {
                        appealTopicId: this.state.selectedTopicId,
                        taskTags: tags
                    }
                ]
            };
            let response = await this.apiAppealRequest.CreateAppeal(command);

            if (response.result) {
                if (this.props.accounts.length !== 0)
                    await this.props.UpdateAccountAppealsAction(this.props.accounts[this.props.selectedAccount].balance.personalAccountId);
                await this.setState({ appealInProgress: false, appealSuccessIsOpen: true, selectedTopicId: "", selectedTagsInfo: [], fileLoading: false });
            }
            else {
                ToastNotificationManager.SendToast({
                    type: NotificationTypeEnum.danger,
                    message: `Ошибка создания заявки. Повторите позднее`,
                });
                await this.setState({ appealInProgress: false, fileLoading: false });
            }

        }
    }

    private CheckValid() {
        let result = true;
        if (this.props.accounts.length === 0 && this.state.serviceObjectId === null)
            return false;
        if (this.state.selectedTopicId === "" || this.state.selectedTagsInfo.length === 0)
            return false;
        this.state.selectedTagsInfo.forEach(e => {
            e.params.forEach(el => {
                let par = e.parameters[el.parameterName]

                if (el.isRequired) {
                    if (par === undefined || par === null)
                        result = false;
                    else {
                        switch (el.parameterTagType) {
                            case ParameterTagTypeEnum.Text:
                            case ParameterTagTypeEnum.TextArea:
                            case ParameterTagTypeEnum.Link:
                                result = par.text !== ""; break;
                            case ParameterTagTypeEnum.File:
                                result = par.file !== null; break;
                            case ParameterTagTypeEnum.FileCollection:
                                result = par.files !== null && par.files.lenght !== 0; break;
                            case ParameterTagTypeEnum.Date:
                                result = par.date !== null; break;
                            case ParameterTagTypeEnum.CheckReadObly:
                                result = par.bool !== null; break;
                            default: true
                        }
                    }
                }
            })
        })
        return result;
    }

    private async SetScore() {
        await this.setState({ scoreInProgress: true })
        let response = await this.apiAppealRequest.SetQuality(this.state.scoredTaskTagId, this.state.selectedScore, this.state.scoreComment)
        if (!response.result) {
            ToastNotificationManager.SendToast({
                type: NotificationTypeEnum.danger,
                message: `Ошибка оценки заявки. Повторите позднее`,
            });
            await this.setState({ scoreInProgress: false })
        }
        else {
            await this.props.UpdateAccountAppealQualityAction(this.state.scoredTaskTagId, this.state.selectedScore)
            if (this.state.selectedScore === 5)
                await this.setState({ scoreInProgress: false, ratingHighIsOpen: true })
            else
                await this.setState({ scoreInProgress: false, ratingIsOpen: true })

        }
    }

    public render() {
        let isValid = this.CheckValid();
        var account = this.props.accounts[this.props.selectedAccount]
        let tags = this.props.tags.filter(e => e.appealTopicId === this.state.selectedTopicId)
        return (
            <>
                {false
                    ? <Loader />
                    : <>
                        {this.state.fileLoading || this.state.appealInProgress && <div className='blocker' onClick={(e) => e.stopPropagation()} />}
                        <Modal isOpen={this.state.appealCreateIsOpen} onClose={() => !this.state.appealInProgress && this.setState({ appealCreateIsOpen: false })}>
                            <div className='appeal__create'>
                                <div className='appeal__modal_header'>
                                    <div className=' appeal__modal_header_button button' style={{ display: "none" }}>
                                        <BackIcon />
                                    </div>
                                    <div className='modal-header-large'>Оставить обращение</div>
                                    <div className=' appeal__modal_header_button button' onClick={() => !this.state.appealInProgress && this.setState({ appealCreateIsOpen: false })}>
                                        <CloseIcon />
                                    </div>
                                </div>

                                {this.props.accounts.length !== 0 &&
                                    <InfoPanel data={[
                                        { title: "Адрес", value: this.props.accounts[this.props.selectedAccount].balance.address },
                                        { title: "Лицевой счет", value: this.props.accounts[this.props.selectedAccount].balance.personalAccount }]} />}
                                {this.props.accounts.length === 0 &&
                                    <AddressInput isValid={this.state.serviceObjectId !== null} SetServiceObject={(e) => {
                                        if (e == null)
                                            this.setState({ serviceObjectId: null })
                                        else
                                            this.setState({ serviceObjectId: e.serviceObjectId })
                                    }} />}

                                <div className='appeal__create_form'>
                                    <ParamSelector<AppealTopic>
                                        title='Тема обращения'
                                        options={this.props.topics}
                                        option_onClick={element => this.setState({ selectedTopicId: element.appealTopicId, selectedTagsInfo: [] })}
                                        getSelected={element => element.appealTopicId === this.state.selectedTopicId}
                                        getValue={element => element.appealTopicName} />

                                    {tags.length !== 0 && <ParamSelector<AppealTag>
                                        title='Выберите разделы'
                                        options={tags}
                                        option_onClick={async element => {
                                            if (this.state.selectedTagsInfo.map(e => e.id).includes(element.appealTagId)) {
                                                let newSelectedTagsInfo = this.state.selectedTagsInfo.slice().filter(e => e.id !== element.appealTagId);
                                                await this.setState({ selectedTagsInfo: newSelectedTagsInfo })
                                            }
                                            else {
                                                let newSelectedTagsInfo = this.state.selectedTagsInfo.slice();
                                                newSelectedTagsInfo.push({ id: element.appealTagId, isLoading: false, params: [], appealName: element.appealTagName, appealAdditionalTagIds: [], parameters: {} });
                                                let params = await this.apiAppealRequest.GetAppealTagParameterInformation(element.appealTagId);

                                                if (!params.result) {
                                                    ToastNotificationManager.SendToast({
                                                        type: NotificationTypeEnum.danger,
                                                        message: `Ошибка загрузки параметров раздела.`,
                                                    });
                                                }
                                                else {
                                                    newSelectedTagsInfo[newSelectedTagsInfo.length - 1].isLoading = true;
                                                    newSelectedTagsInfo[newSelectedTagsInfo.length - 1].params = params?.data || [];

                                                    await this.setState({ selectedTagsInfo: newSelectedTagsInfo })
                                                }
                                            }
                                        }}
                                        getSelected={element => this.state.selectedTagsInfo.map(e => e.id).includes(element.appealTagId)}
                                        getValue={element => element.appealTagName} />}


                                    {this.state.selectedTagsInfo.map((element, index) => {
                                        return <div className='appeal__create_inputs' key={index}>
                                            <div className='text-bold'>{element.appealName}</div>
                                            {this.ParametersInput_Render(index)}
                                            {this.props.addTags.filter(e => e.appealTagId === element.id).length > 0 &&
                                                <DataString title='Выберите подразделы'><ParamSelector<AppealAdditionalTag>
                                                    options={this.props.addTags.filter(e => e.appealTagId === element.id)}
                                                    option_onClick={element => {
                                                        let newSelectedTagsInfo = this.state.selectedTagsInfo.slice();
                                                        let i = newSelectedTagsInfo[index].appealAdditionalTagIds.findIndex(e => element.appealAdditionalTagId === e);
                                                        if (i === -1)
                                                            newSelectedTagsInfo[index].appealAdditionalTagIds.push(element.appealAdditionalTagId)
                                                        else newSelectedTagsInfo[index].appealAdditionalTagIds.splice(i, 1);
                                                        this.setState({ selectedTagsInfo: newSelectedTagsInfo })
                                                    }}
                                                    getSelected={element => this.state.selectedTagsInfo[index].appealAdditionalTagIds.includes(element.appealAdditionalTagId)}
                                                    getValue={element => element.appealAdditionalTagName} />
                                                </DataString>
                                            }
                                        </div>
                                    })}
                                </div>
                                <div className='appeal__create_button_wrapper '>
                                    <div className='name-passive--6'>*Обязательное поле</div>
                                    <div className={`appeal__create_button button-text button ${!isValid && "disabled"}`}
                                        onClick={async () => isValid && !this.state.appealInProgress && await this.CreateAppeal()}>
                                        {this.state.appealInProgress ? <Spinner /> : "Отправить"}</div>
                                    <div className='appeal__create_button_caption text-norm'>
                                        Нажимая на кнопку, вы даёте согласие на обработку персональных данных
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <Modal isOpen={this.state.appealViewIsOpen} onClose={() => this.setState({ appealViewIsOpen: false })}>
                            <div className='appeal__view' >
                                <div className={`appeal__view_loader ${!this.state.viewInProgress && "isClose"}`}>
                                    <Loader />
                                </div>

                                <div className='appeal__modal_header'>
                                    <div className='modal-header-large'>Заявка №{this.state.uploadedTaskTag?.serialNumber}</div>
                                    <div className=' appeal__modal_header_button button'
                                        onClick={() => this.setState({ appealViewIsOpen: false })}>
                                        <CloseIcon />
                                    </div>
                                </div>
                                <div className='appeal__view_content'>
                                    <div className={`appeal__view_content_data`}>
                                        <div className='appeal__view_data'>
                                            <DataString isNormal={true} title='Адрес' value={account !== undefined ? account.balance.address : ""} />
                                            <DataString isNormal={true} title='Лицевой счет' value={account !== undefined ? account.balance.personalAccount : ""} />
                                            <DataString isNormal={true} title='Дата создания' value={moment(this.state.uploadedTaskTag?.dateCreate).format("DD.MM.YYYY")} />
                                            <DataString isNormal={true} title='Тема' value={this.state.uploadedTaskTag?.appealTopicName} />
                                            <DataString isNormal={true} title='Раздел' value={this.state.uploadedTaskTag?.appealTagName} />
                                            <DataString isNormal={true} title='Дата выполнения' value={moment(this.state.uploadedTaskTag?.dateExecution).format("DD.MM.YYYY")} />
                                        </div>
                                        {this.ParametersView_Render(this.state.uploadedTaskTag?.taskTagParameters)}
                                        <div className='devider--horizontal'></div>
                                        <div className='appeal__view_additional-data'>
                                            {this.state.uploadedTaskTag !== null && this.state.uploadedTaskTag?.quality !== null && this.state.uploadedTaskTag.quality !== 0 ?
                                                <DataString title='Оцените работу по заявке' >
                                                    <ScoreSelector selectedScore={this.state.uploadedTaskTag.quality} isView={true} />
                                                </DataString>
                                                :
                                                <DataString title='Ваша оценка' >
                                                    <ScoreSelector selectedScore={this.state.selectedScore}
                                                        score_onClick={(score) => this.setState({ selectedScore: score, scoredTaskTagId: this.state.uploadedTaskTag?.taskTagId || "" })} />
                                                </DataString>}
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </Modal>

                        <Modal isOpen={this.state.selectedScore > 0} onClose={() => { this.setState({ selectedScore: 0 }) }}>
                            <div className='appeal__view_content_rating'>
                                <div className=' appeal__modal_header_button_abs button'
                                    onClick={() => this.setState({ selectedScore: 0 })}>
                                    <CloseIcon />
                                </div>
                                <div className='appeal__view_content_rating_score'>
                                    <div className='title-bold'>Оцените работу по заявке</div>
                                    <ScoreSelector selectedScore={this.state.selectedScore} score_onClick={(score) => this.setState({ selectedScore: score })} />
                                </div>
                                <DataString title='Отзыв'>
                                    <input className='value-text--normal appeal__view_content_rating_input' value={this.state.scoreComment} onChange={(e) => this.setState({ scoreComment: e.currentTarget.value })}></input>
                                </DataString>
                                <div className='appeal__view_content_rating_button button button-text'
                                    onClick={() => this.SetScore()}>{this.state.scoreInProgress ? <Spinner /> : "Отправить"}</div>
                            </div>
                        </Modal>

                        <Popup isOpen={this.state.appealSuccessIsOpen} onClose={() => this.setState({ appealSuccessIsOpen: false, appealCreateIsOpen: false })}>
                            <div className='info-popup'>
                                <div className=' appeal__modal_header_button_abs button'
                                    onClick={() => this.setState({ appealSuccessIsOpen: false, appealCreateIsOpen: false })}>
                                    <CloseIcon />
                                </div>
                                <div className='info-popup_wrapper'>
                                    <div className='text-bold'>Ваша заявка принята</div>
                                    <div className='name-passive--8'>Отслеживайте срок выполнения и статус в разделе «Заявки»</div>
                                </div>
                                <div className='info-popup_button button button-text'
                                    onClick={() => this.setState({ appealSuccessIsOpen: false, appealCreateIsOpen: false })}>Закрыть</div>
                            </div>
                        </Popup>

                        <Popup isOpen={this.state.ratingIsOpen} onClose={() => this.setState({ ratingIsOpen: false, selectedScore: -1, scoredTaskTagId: "", appealViewIsOpen: false })}>
                            <div className='info-popup'>
                                <div className=' appeal__modal_header_button_abs button'
                                    onClick={() => this.setState({ ratingIsOpen: false, selectedScore: -1, scoredTaskTagId: "", appealViewIsOpen: false })}>
                                    <CloseIcon />
                                </div>
                                <div className='info-popup_wrapper'>
                                    <div className='text-bold'>Спасибо!</div>
                                    <div className='name-passive--8'>Оценка отправлена, с вами свяжется менеджер для уточнения деталей по заявке</div>
                                </div>
                                <div className='info-popup_button button button-text'
                                    onClick={() => this.setState({ ratingIsOpen: false, selectedScore: -1, scoredTaskTagId: "", appealViewIsOpen: false })}>Закрыть</div>
                            </div>
                        </Popup>
                        <Popup isOpen={this.state.ratingHighIsOpen} onClose={() => this.setState({ ratingHighIsOpen: false, selectedScore: -1, scoredTaskTagId: "", appealViewIsOpen: false })}>
                            <div className='info-popup'>
                                <div className=' appeal__modal_header_button_abs button'
                                    onClick={() => this.setState({ ratingHighIsOpen: false, selectedScore: -1, scoredTaskTagId: "", appealViewIsOpen: false })}>
                                    <CloseIcon />
                                </div>
                                <div className='info-popup_wrapper'>
                                    <div className='text-bold'>Спасибо!</div>
                                    <div className='name-passive--8'>Оценка отправлена</div>
                                </div>
                                <div className='info-popup_button button button-text'
                                    onClick={() => this.setState({ ratingHighIsOpen: false, selectedScore: -1, scoredTaskTagId: "", appealViewIsOpen: false })}>Закрыть</div>
                            </div>
                        </Popup>

                        <Popup isOpen={this.state.addPaIsOpen} onClose={() => this.setState({ addPaIsOpen: false })}>
                            <div className='appeal__add-pa'>
                                <div className=' appeal__modal_header_button_abs button'
                                    onClick={() => this.setState({ addPaIsOpen: false })}>
                                    <CloseIcon />
                                </div>
                                <div className='appeal__add-pa_wrapper'>
                                    <div className='text-bold--white'>Добавьте лицевой счет</div>
                                    <div className='name-passive--8 white'>Заполните свои данные, чтобы отслеживать статус выполнения заявки в личном кабинете</div>
                                </div>
                                <div className='appeal__add-pa_button-wrapper'>
                                    <div className='button button-text'
                                        onClick={() => this.setState({ appealCreateIsOpen: true, addPaIsOpen: false })}>Оформить заявку</div>
                                    <div className='button button-text purple'
                                        onClick={() => { this.setState({ addPaIsOpen: false }); this.props.SetAttachOpen(true) }}>Заполнить</div>
                                </div>

                            </div>
                        </Popup>


                        <div className='appeal'>
                            <div className='appeal_wrapper'>
                                {<div className='appeal__my-appeal'>
                                    <div className='text-bold'>Мои заявки</div>
                                    <div className='name-passive--8 '>Оставьте заявку на ремонт оборудования, вызов мастера или покупку дополнительных ключей</div>
                                    <div className='appeal__my-appeal_button button button-text' onClick={() => { this.props.accounts.length === 0 ? this.setState({ addPaIsOpen: true }) : this.setState({ appealCreateIsOpen: true }) }}>Оставить заявку</div>
                                </div>}
                                <Switcher
                                    options={["В работе", "Выполненные"]}
                                    selectedOption={this.state.selectedOption}
                                    option_onClick={(index) => this.setState({ selectedOption: index })}
                                />
                            </div>
                            <div className='appeal_appeals_wrapper'>
                                {this.Appeals_Render()}
                            </div>
                        </div>
                    </>
                }

            </>
        );
    }
};

export default connect(
    (state: ApplicationState) => ({
        ...state.appealList,
        ...state.AccountState,
        ...state.guide,
        accounts: state.AccountState?.accounts || [],
        isLoadAccount: true
    }),
    dispatchAction
)(AppealListPage as any);
